import axios from "axios";
import notify from "devextreme/ui/notify";

export const instance = axios.create({
  timeout: 10000
});
